<template>
  <div class="grid grid-cols-3 gap-2">
    <button
      v-for="digit in DIGITS"
      :key="digit"
      type="button"
      class="btn btn-lg btn-neutral h-14 text-xl sm:h-16"
      :disabled="disabled"
      @click="emit('digit', digit)"
    >
      {{ digit }}
    </button>

    <button
      type="button"
      class="btn btn-lg btn-ghost h-14 sm:h-16"
      :disabled="disabled"
      :aria-label="$t('pos.pin-clear')"
      @click="emit('clear')"
    >
      {{ $t('pos.pin-clear') }}
    </button>

    <button
      type="button"
      class="btn btn-lg btn-neutral h-14 text-xl sm:h-16"
      :disabled="disabled"
      @click="emit('digit', '0')"
    >
      0
    </button>

    <button
      type="button"
      class="btn btn-lg btn-ghost h-14 sm:h-16"
      :disabled="disabled"
      :aria-label="$t('pos.pin-backspace')"
      @click="emit('backspace')"
    >
      <FontAwesomeIcon :icon="faDeleteLeft" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { faDeleteLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const DIGITS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'] as const;

defineProps<{ disabled?: boolean }>();

const emit = defineEmits<{
  (e: 'digit', digit: string): void;
  (e: 'backspace'): void;
  (e: 'clear'): void;
}>();
</script>
